export function InstallationFormRequiredMark() {
  return (
    <span className="text-destructive ms-0.5 font-semibold" aria-hidden="true">
      *
    </span>
  )
}
